import { Component } from '@angular/core';
import { KPI_PANEL_IMPORTS, KpiPanelComponent } from 'src/app/panels/components/kpi/kpi-panel/kpi-panel.component';
import { PanelComponent } from 'src/app/panels/components/panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';

@PanelComponent.register
@Component({
  templateUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.html',
  styleUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.scss',
  selector: 'app-kwh-m2-kpi-panel',
  imports: KPI_PANEL_IMPORTS,
})
export class KwhPerM2KpiPanelComponent extends KpiPanelComponent {
  public static override readonly type = PanelType.KwhPerM2Kpi;
  public override title = 'Verbruik t.o.v jaarlimiet';
  public override icon = 'bi-lightning-charge-fill';
  public override unit = DisplayUnit.Percentage;
  public override color = Color.DarkBlue;
}
